module.exports = __webpack_public_path__ + "img/ie.9cc9c2b7.svg";